var exports = {
  "kL": "xcc377c0b--6c979e--container",
  "Qs": "xcc377c0b--6c979e--content",
  "kb": "xcc377c0b--6c979e--left",
  "Ot": "xcc377c0b--6c979e--reasons",
  "l": "xcc377c0b--6c979e--reason",
  "pG": "xcc377c0b--6c979e--right",
  "x6": "xcc377c0b--6c979e--button",
};

module.exports = exports;
